var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.516 11.521v2.148H12v2.627h1.516V24.1h3.113v-7.804h2.09s.195-1.26.29-2.637H16.64v-1.796c0-.268.34-.629.675-.629h1.696V8.5h-2.306c-3.267 0-3.19 2.629-3.19 3.021z",
    fillRule: "nonzero"
  })));
};
export default SvgFacebook;